import { useState, ChangeEvent, FormEvent } from 'react';
import Spinner from 'components/Spinner/Spinner';

import { Div } from 'styles/Styles';
import { FormTitle, StrengthBar, StrengthText } from '../Auth.styled';
import { colors } from 'styles/GlobalStyles';
import { H2, P1 } from 'styles/FontStyles';
import { InputComponent } from 'components/Input/Input';

import { Button } from 'components/Button/Button';
import { resetPassword } from 'services/auth/auth.service';
import { useAppDispatch } from 'app/hooks';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ErrorToast } from 'components/Toasts/Toasts';

export const NewPassword = () => {
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [letterUpperCase, setLetterUpperCase] = useState(false);
  const [letterDigit, setLetterDigit] = useState(false);
  const [letterChar, setLetterChar] = useState(false);
  const [passLength, setPassLength] = useState(false);

  const validation = [
    {
      text: 'Uppercase',
      strength: 1,
      requirement: letterUpperCase,
    },
    {
      text: 'Special Letter',
      strength: 2,
      requirement: letterChar,
    },
    { text: 'Number', strength: 3, requirement: letterDigit },
    { text: '8+character', strength: 4, requirement: passLength },
  ];
  const upperCase = /^(?=.*?[A-Z])/;
  const digit = /^(?=.*?[0-9])/;
  const specChar = /(?=.*?[#?!@$%^&*-])/;

  const code = searchParams.get('code');

  const checkPassword = (e: any) => {
    setPassword(e);

    if (e.match(upperCase)) {
      setLetterUpperCase(true);
    } else {
      setLetterUpperCase(false);
    }

    if (e.match(digit)) {
      setLetterDigit(true);
    } else {
      setLetterDigit(false);
    }

    if (e.match(specChar)) {
      setLetterChar(true);
    } else {
      setLetterChar(false);
    }

    if (e.length >= 8) {
      setPassLength(true);
    } else {
      setPassLength(false);
    }
  };

  const dispatch = useAppDispatch();

  const onFormSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      ErrorToast('Passwords do not match!');
    } else {
      dispatch(resetPassword({ code, password, setLoading, navigate }));
    }

    // setCaptchaLoading(true);

    // window.initGeetest4(
    //   {
    //     captchaId,
    //     language: 'eng',
    //     product: 'bind',
    //     riskType: 'slide',
    //     nativeButton: {
    //       width: '100%',
    //       marginBottom: '20px'
    //     }
    //   },
    //   function (captcha: any) {
    //     captcha.showBox();
    //     captcha
    //       .onReady(function () {
    //         setCaptchaLoading(false);
    //       })
    //       .onSuccess(function () {
    //         const result = captcha.getValidate();
    //         if (validateEmail(id)) {
    //           dispatch(sendResetPasswordEmail({ id, type: 1, result }));
    //         } else if (id.match(digit)) {
    //           dispatch(sendResetPasswordEmail({ id, type: 2, result }));
    //         } else {
    //           dispatch(sendResetPasswordEmail({ id, type: 3, result }));
    //         }
    //       })
    //       .onError(function () {
    //         setCaptchaLoading(false);
    //       });
    //   }
    // );
  };

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <Div $box $width='50%' $widthSM='100%'>
        <H2 center m='50px 0' color={colors.primary}>
          Create Your New Password
        </H2>

        <form onSubmit={onFormSubmit}>
          <InputComponent
            placeholder='Enter your new password'
            type='password'
            label='New Password'
            value={password}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              checkPassword(e.target.value)
            }
          />

          <InputComponent
            placeholder='Confirm your new password'
            type='password'
            label='Confirm Password'
            value={confirmPassword}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setConfirmPassword(e.target.value)
            }
          />
          <Div $flex $between>
            {validation.map((item, index) => {
              return (
                <StrengthBar
                  key={index}
                  color={
                    password.length > 0
                      ? item.requirement
                        ? colors.success500
                        : colors.error
                      : colors.neutral400
                  }
                >
                  <StrengthText
                    color={
                      password.length > 0
                        ? item.requirement
                          ? colors.success500
                          : colors.error
                        : colors.neutral400
                    }
                  >
                    {item.text}
                  </StrengthText>
                </StrengthBar>
              );
            })}
          </Div>
          <Button
            style={{ marginTop: 60 }}
            type='submit'
            disabled={
              !letterUpperCase ||
              !letterDigit ||
              !letterChar ||
              !passLength ||
              password === '' ||
              confirmPassword === ''
            }
          >
            Continue
          </Button>
        </form>
      </Div>
    </>
  );
};
